import React from 'react';
import { useTranslation } from 'react-i18next';
import ServicePageLayout from '../../component/common/servicesPagesLayout';

const BlockchainPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '📝',
      title: t('blockchain.features.1.title'),
      description: t('blockchain.features.1.desc'),
    },
    {
      icon: '🔗',
      title: t('blockchain.features.2.title'),
      description: t('blockchain.features.2.desc'),
    },
    {
      icon: '🔌',
      title: t('blockchain.features.3.title'),
      description: t('blockchain.features.3.desc'),
    },
    {
      icon: '💰',
      title: t('blockchain.features.4.title'),
      description: t('blockchain.features.4.desc'),
    },
    {
      icon: '🧠',
      title: t('blockchain.features.5.title'),
      description: t('blockchain.features.5.desc'),
    },
    {
      icon: '🛡️',
      title: t('blockchain.features.6.title'),
      description: t('blockchain.features.6.desc'),
    },
  ];

  const process = [
    { title: t('blockchain.process.1.title'), description: t('blockchain.process.1.desc') },
    { title: t('blockchain.process.2.title'), description: t('blockchain.process.2.desc') },
    { title: t('blockchain.process.3.title'), description: t('blockchain.process.3.desc') },
    { title: t('blockchain.process.4.title'), description: t('blockchain.process.4.desc') },
  ];

  const whyChooseUs = [
    { stat: '15+', label: t('blockchain.why.1.label') },
    { stat: '100%', label: t('blockchain.why.2.label') },
    { stat: '3+', label: t('blockchain.why.3.label') },
    { stat: '24/7', label: t('blockchain.why.4.label') },
  ];

  const techStack = [
    { icon: '⟠', name: 'Ethereum' },
    { icon: '🔷', name: 'Solidity' },
    { icon: '🌐', name: 'Web3.js' },
    { icon: '📦', name: 'Hardhat' },
    { icon: '🔺', name: 'Polygon' },
    { icon: '⚡', name: 'Solana' },
    { icon: '🔐', name: 'OpenZeppelin' },
    { icon: '📊', name: 'The Graph' },
    { icon: '🦊', name: 'MetaMask' },
    { icon: '💎', name: 'Ethers.js' },
  ];

  const faqs = [
    {
      question: t('blockchain.faq.q1'),
      answer: t('blockchain.faq.a1'),
    },
    {
      question: t('blockchain.faq.q2'),
      answer: t('blockchain.faq.a2'),
    },
    {
      question: t('blockchain.faq.q3'),
      answer: t('blockchain.faq.a3'),
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Blockchain Development Services',
    provider: {
      '@type': 'Organization',
      name: 'BringIt Go',
      url: 'https://www.bringitgo.tech',
    },
    description: 'Professional blockchain development including smart contracts, DApp development, cryptocurrency solutions, and blockchain consulting.',
    url: 'https://www.bringitgo.tech/blockchain',
    areaServed: 'Worldwide',
    serviceType: 'Blockchain Development',
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <ServicePageLayout
      accentClass="service-accent-blockchain"
      badge={t('blockchain.badge')}
      title={t('blockchain.heroTitle')}
      description={t('blockchain.heroDescription')}
      features={features}
      process={process}
      whyChooseUs={whyChooseUs}
      techStack={techStack}
      faqs={faqs}
      seo={{
        title: t('blockchain.seo.title'),
        description: t('blockchain.seo.description'),
        canonical: 'https://www.bringitgo.tech/blockchain',
      }}
      structuredData={[structuredData, faqStructuredData]}
    />
  );
};

export default BlockchainPage;
